/* IFG eCommerce 23/09/2026 - Avanzamento automatico della sezione "Immagini con testo a scorrimento"
   (sections/images-with-text-scroll.liquid, impostazioni "Avanzamento automatico").
   Su mobile e tablet la sezione e' un carosello a scorrimento laterale: ogni N secondi passa
   alla slide successiva usando il metodo next() del componente del tema. Su desktop la sezione
   cambia immagine con lo scorrimento della pagina e l'avanzamento automatico non si applica.
   Si ferma quando la sezione non e' visibile, quando la scheda del browser e' nascosta, mentre
   l'utente tocca il carosello e se il sistema chiede movimento ridotto. Dopo un cambio manuale
   (swipe o pallini) il conteggio riparte da zero. Nessuna modifica a theme.js. */
(function () {
  if (window.ifgAutoplayScroll) return;
  window.ifgAutoplayScroll = true;

  var mq = (window.themeVariables && window.themeVariables.mediaQueries && window.themeVariables.mediaQueries.md) || 'screen and (min-width: 1000px)';
  var desktop = window.matchMedia(mq);
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(el) {
    if (el.ifgAutoplay) return;
    var seconds = parseInt(el.getAttribute('data-ifg-autoplay'), 10);
    if (!seconds || seconds < 2) seconds = 5;
    var state = { timer: null, visible: false, touching: false };
    el.ifgAutoplay = state;

    function stop() {
      if (state.timer) { clearTimeout(state.timer); state.timer = null; }
    }
    function schedule() {
      stop();
      if (!state.visible || state.touching || desktop.matches || reduce.matches || document.hidden) return;
      state.timer = setTimeout(function () {
        if (typeof el.next === 'function' && el.cells && el.cells.length > 1) el.next();
      }, seconds * 1000);
    }

    el.addEventListener('carousel:settle', schedule);
    el.addEventListener('pointerdown', function () { state.touching = true; stop(); });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
      el.addEventListener(evt, function () { if (state.touching) { state.touching = false; schedule(); } });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        state.visible = entries[0].isIntersecting;
        if (state.visible) { schedule(); } else { stop(); }
      }, { threshold: 0.3 }).observe(el);
    } else {
      state.visible = true;
      schedule();
    }

    document.addEventListener('visibilitychange', schedule);
    if (desktop.addEventListener) desktop.addEventListener('change', schedule);
  }

  function init() {
    document.querySelectorAll('images-with-text-scroll[data-ifg-autoplay]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
